import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import { RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineClose } from "react-icons/ai";
import { NavItems } from "../../NavItems";

export const MobileMenu = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [subMenuOpen, setSubMenuOpen] = useState({});

	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	const toggleSubMenu = (path, e) => {
		e.preventDefault();
		setSubMenuOpen((prevState) => ({
			...prevState,
			[path]: !prevState[path],
		}));
	};

	useEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden"; // Disable scroll
		} else {
			document.body.style.overflow = "auto"; // Enable scroll
		}

		return () => {
			document.body.style.overflow = "auto"; // Clean up when component is unmounted or menu is closed
		};
	}, [isOpen]);

	const handleMenuItemClick = (submenu, e) => {
		if (!submenu) {
			setIsOpen(false); // Close the menu when an item is clicked
		} else {
			e.preventDefault();
		}
	};

	const renderNavItems = (items) =>
		items.map(({ path, label, submenu }) => (
			<li
				key={path}
				className="mobile-menu__item"
			>
				{submenu ? (
					<>
						<button
							className="mobile-menu__sub-submenu-btn"
							onClick={(e) => toggleSubMenu(path, e)}
						>
							{label}
						</button>
						{subMenuOpen[path] && (
							<ul className="mobile-menu__sub-submenu__list">
								{renderNavItems(submenu)}
							</ul>
						)}
					</>
				) : (
					<NavLink
						to={path}
						className="mobile-menu__link"
						onClick={(e) => handleMenuItemClick(submenu, e)} // Close the menu when item is clicked
					>
						{label}
					</NavLink>
				)}
			</li>
		));

	return (
		<nav className="mobile-menu">
			<button
				className="mobile-menu-toggle"
				onClick={toggleMenu}
			>
				{isOpen ? (
					<AiOutlineClose size={28} />
				) : (
					<RxHamburgerMenu size={28} />
				)}
			</button>

			{isOpen && (
				<div className={`mobile-menu__content ${isOpen ? "open" : ""}`}>
					<ul className="mobile-menu__list">
						{renderNavItems(NavItems)}
					</ul>
				</div>
			)}
		</nav>
	);
};
